exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-028c1f59] .el-card__body,[data-v-028c1f59] .el-tabs{height:100%}[data-v-028c1f59] .el-tabs__content{height:calc(100% - 54px)!important;position:inherit}[data-v-028c1f59] .el-tabs__content .el-tab-pane{height:100%}", ""]);

// exports
